import { useEffect, useState } from "react";
import { useAsyncDebounce } from "react-table";

export function useDebouncedFilter<T>(filterValue: T, setFilter: (v: T) => void, defaultWait = 300) {
  const [ value, setValue ] = useState(filterValue);

  useEffect(() => {
    setValue(filterValue);
  }, [ filterValue ]);

  const onFilterChange = useAsyncDebounce(val => {
    setFilter(val || undefined);
  }, defaultWait);

  const onChange = (v: any) => {
    const newValue = v === null ? undefined : v;
    setValue(newValue);
    onFilterChange(newValue);
  };

  return [ value, onChange ];
}
